import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLottie } from "lottie-react";

import { useTheme } from "@mui/styles";
import axios from "axios";
import { config } from "../../../config";

import { Grid, Typography, Box, Dialog, Alert, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import Banner from "../../../assets/images/banner.png";
import confetti from "../../../assets/lotties/confetti.json";

import HeaderBubbles from "./HeaderBubbles";
import Bubble from "../../../components/Bubble";
import Icon from "../../../components/Icon";
import { makeHTML, makeResultUpdateBody } from "../utils";
import { sectionKeys, SelectASection } from "../Wrapper";
import { EmailCapture } from "./EmailCapture";

import { v4 as uuidv4 } from "uuid";

// const IF = styled.iframe`
//   border: none;
// `;

// const vidDiv = (url, width, height) => {
//   if (!url) {
//     return <></>;
//   }
//   return (
//     <Box
//       sx={{
//         width: width || "100vw",
//         height: height || "50vw",
//         maxWidth: "800px",
//         maxHeight: "450px",
//         margin: "auto",
//       }}
//     >
//       <IF
//         src={`https://api.vadoo.tv/iframe_test?id=${url}`}
//         width="100%"
//         height="100%"
//       />
//     </Box>
//   );
// };

const ResultDiv = styled.div`
  width: 80px;
  height: 80px;
  margin: auto;
  position: relative;
`;

// const ResultDivImg = styled.img`
//   width: 100%;
//   background: white;
//   border-radius: 50%;
// `;

const ResultDivBubbleContainer = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
`;

// const LogoImg = styled.img`
//   position: absolute;
//   left: 10%;
//   top: 20%;
//   width: 100px;
// `;

const SLink = styled.a`
  color: red;
`;

// const getFontSize = (name) => {
//   if (name === "arla") {
//     return "1.2em";
//   }
//   return "1em";
// };
export default function Results({
  history,
  finalGrades,
  sections,
  overall,
  headers,
  overallGrade,
  conditionals,
  completedSections,
  startSection,
}) {
  const { View } = useLottie(
    {
      loop: false,
      autoplay: true,
      animationData: confetti,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    },
    {
      height: "100%",
      widht: "100%",
    }
  );
  const [open, setOpen] = useState([]);

  const [showEmail, setShowEmail] = useState(true);
  const [showEmail2, setShowEmail2] = useState(true);
  const [showNextSteps, setShowNextSteps] = useState(false);

  const theme = useTheme();

  const toggle = (s) => {
    const newOpen = [...open];
    if (newOpen.includes(s)) {
      setOpen(newOpen.filter((sc) => sc !== s));
    } else {
      setOpen([...newOpen, s]);
    }
  };

  const heads = { ...headers };
  for (const s of Object.keys(history)) {
    if (!completedSections.includes(s)) {
      delete heads[s];
    }
  }

  // const updateSql = async () => {
  //   await axios({
  //     method: "POST",
  //     url: `${config.apiUrl}/quiz`,

  //     data: JSON.stringify(
  //       makeResultUpdateBody(0, history, finalGrades, sections, overallGrade)
  //     ),
  //   });
  // };

  const handleSubmit = async (name, email) => {
    await axios({
      method: "POST",
      url: "/.netlify/functions/registerContact",
      data: JSON.stringify({ firstName: name, email }),
    }).catch();
    await sendEmail(name, email);
    setShowEmail(false);
  };

  const navigate = (selectedSection) => {
    window.location.replace(
      `https://ukcareguide.co.uk/financial-tool?x=${selectedSection}`
    );
  };

  const sendEmail = async (name, email) => {
    await axios({
      method: "POST",
      url: "/.netlify/functions/emailResults",
      // url: "https://upbeat-montalcini-34e93f.netlify.app/.netlify/functions/emailResults",
      data: JSON.stringify({
        body: makeHTML(
          { history, finalGrades, sections, overall, overallGrade },
          name,
          theme.palette.primary.main
        ),
        recipient: email,
      }),
    });
  };

  // const postData = async () => {
  //   setLoading(true);
  //   updateSql();
  //   sendEmail();
  // };

  // useEffect(() => {
  //   postData();
  // }, []);

  const postData = async () => {
    // create a user and post data
    let uuid = localStorage.getItem("uuid");
    const userData = JSON.parse(
      localStorage.getItem("userInfo") || JSON.stringify({})
    );
    const userInfo = [
      userData.age.toString(),
      userData.gender,
      userData.location,
    ];

    if (!uuid) {
      uuid = uuidv4();

      //create user
      await axios({
        method: "POST",
        url: `${config.apiUrl}/user`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          uuid,
          org: "ukcare",
          email: "",
          email2: "",
          questions: userInfo,
        }),
      });

      localStorage.setItem("uuid", uuid);
    }

    //post results
    await axios({
      method: "POST",
      url: `${config.apiUrl}/quiz`,
      data: JSON.stringify({
        ...makeResultUpdateBody(
          uuid,
          history,
          finalGrades,
          sections,
          overallGrade,
          userInfo
        ),
        uuid,
      }),
    });
  };

  const [showConfetti, setShowConfetti] = useState(true);
  useEffect(() => {
    postData();

    setTimeout(() => {
      setShowConfetti(false);
    }, 1000);
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setShowNextSteps(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Grid container spacing={2} textAlign="center">
      {showConfetti && (
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100vw",
            zIndex: 999,
          }}
        >
          {View}
        </Box>
      )}
      <Grid item xs={12} md={8} m={"auto"} my={4} sx={{ position: "relative" }}>
        <img src={Banner} width="100%" />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <Typography
          variant="h4"
          sx={{
            color: "primary.main",
            display: "inline-block",
            background: "white",
            px: 5,
            py: 3,
            borderRadius: 10,
            boxShadow: "0px 0px 20px 20px rgba(0,0,0,0.05)",
            transform: "translateY(-50%)",
            fontWeight: "bold",
          }}
        >
          Congratulations on completing your assessment
        </Typography>
      </Grid>
      <Grid item xs={12} md={8} m={"auto"} my={4}>
        <Typography variant="h3">Here are your results</Typography>
      </Grid>
      <Grid item xs={12} md={8} m={"auto"}>
        <Typography variant="h4" mb={4}>
          {localStorage.getItem("fullQuiz")
            ? "Your overall Financial Fitness score"
            : `Your overall Financial Fitness score for ${
                sectionKeys.find((s) => s.key === startSection).value
              }`}
        </Typography>
        <Bubble score={overallGrade} size={200} spin />
      </Grid>

      {localStorage.getItem("fullQuiz") && (
        <Grid item xs={12} md={8} m={"auto"} my={4}>
          <Box
            sx={{
              borderRadius: 3,
              border: "1px solid",
              borderColor: "primary.main",
              mb: 10,
              maxHeight: "350px",
            }}
          >
            <Typography variant="h4" p={3}>
              Your individual financial fitness scores
            </Typography>
            <Box
              sx={{
                background: "white",
                borderRadius: 3,
                mx: 3,
                [theme.breakpoints.down("md")]: {
                  mx: 0,
                },
              }}
            >
              <HeaderBubbles headers={heads} conditionals={conditionals} />
            </Box>
          </Box>
        </Grid>
      )}

      <Grid
        item
        xs={12}
        md={8}
        m={"auto"}
        sx={{
          [theme.breakpoints.down("md")]: {
            mt: 10,
          },
        }}
      >
        <Typography variant="h4" p={2}>
          Understanding your scores and what areas to prioritise
        </Typography>
        <Typography p={2} sx={{ whiteSpace: "pre-line", textAlign: "left" }}>
          Based on your answers, and using a traffic light system, we have
          scored you between an A and an F, with A being the highest score and F
          the lowest. The areas with the lowest scores are those that you need
          to prioritise.
          <br></br>
          <br></br>
          We have priorities your financial fitness score based on what you
          scored for each section, with the area with the lowest scores being
          first. We recommend that you look at the actionable tips and
          suggestions for further reading based on the areas with your lowest
          score.
        </Typography>
      </Grid>
      {/* <Grid item xs={12} md={8} m={"auto"}>
        <Typography variant="h4" p={2} m="auto">
          Your overall score
        </Typography>
      </Grid> */}
      {/* <Grid item xs={12} md={8} m="auto">
        {vidDiv(overall.videos[overallGrade].split("=")[1])}
      </Grid> */}
      {/* <Grid item xs={12} md={8} m={"auto"}>
        <Typography sx={{ whiteSpace: "pre-line", textAlign: "left", p: 2 }}>
          {overall.scoring[overallGrade]}
        </Typography>
      </Grid> */}
      {/* <Grid item xs={12} md={8} m={"auto"} my={6}>
        <Typography variant="h4">
          A breakdown of your individual results
        </Typography>
      </Grid> */}
      {Object.keys(history)
        .filter((s) =>
          completedSections
            ? completedSections.includes(s)
            : history[s].length > 2
        )
        .sort((a, b) => {
          return headers[a].grade > headers[b].grade ? -1 : 0;
        })
        .map((s) => {
          return (
            <>
              <br />
              <Grid
                item
                xs={12}
                md={8}
                key={s}
                p={2}
                sx={{
                  display: "block",
                  margin: "20px auto",
                  borderRadius: "20px",
                  border: "1px solid",
                  borderColor: "primary.main",
                  paddingBottom: 8,
                }}
              >
                <Box
                  sx={{
                    maxHeight: 200,
                    p: 2,
                    backgroundColor: "primary.main",
                    borderRadius: 3,
                  }}
                >
                  <ResultDiv>
                    <Icon width="100%" section={s} />
                    <ResultDivBubbleContainer>
                      <Bubble score={finalGrades[s]} size={55} />
                    </ResultDivBubbleContainer>
                  </ResultDiv>
                  <Typography
                    variant="h3"
                    sx={{
                      background: "white",
                      p: 1,
                      borderRadius: 3,
                      boxShadow: "0px 0px 20px 20px rgba(0,0,0,0.05)",
                      transform: "translateY(50%)",
                    }}
                  >
                    {["Renter", "Homeowner"].includes(sections[s].title.trim())
                      ? "Your Home"
                      : sections[s].title}
                  </Typography>
                  <Box
                    sx={{
                      mt: 6,
                    }}
                  >
                    <Button variant="contained" onClick={() => toggle(s)} sx={{
                      borderRadius: 5, 
                      textTransform: 'none'
                    }}>
                      {open.includes(s) ? "Collapse" : "Show more"}
                    </Button>
                  </Box>
                </Box>
                {open.includes(s) && (
                  <>
                    {/* {sections[s].videos.a && (
                      <Box
                        sx={{
                          mt: 8,
                        }}
                      >
                        {vidDiv(
                          sections[s].videos[finalGrades[s]].split("=")[1],
                          "60vw",
                          "30vw"
                        )}
                      </Box>
                    )} */}
                    <Box
                      p={2}
                      pt={4}
                      mt={6}
                      sx={{
                        mt: 4,
                        [theme.breakpoints.down("md")]: {
                          mt: 10,
                        },
                      }}
                    >
                      <Typography whiteSpace="pre-line" textAlign={"left"}>
                        {sections[s].scoring[finalGrades[s]]}
                      </Typography>
                    </Box>
                    {history[s]
                      .filter((a) => a.comment)
                      .map((a, idx) => {
                        return (
                          <div key={idx + s}>
                            <Box p={2}>
                              <Typography
                                pb={2}
                                textAlign="left"
                                variant="h4"
                                sx={{ color: "primary.main" }}
                              >
                                {a.heading}
                              </Typography>
                              <Typography
                                sx={{
                                  whiteSpace: "pre-line",
                                  textAlign: "left",
                                }}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: a.comment,
                                  }}
                                />
                              </Typography>
                              {a.link.title && (
                                <>
                                  <Typography
                                    textAlign="left"
                                    mt={2}
                                    sx={{ fontWeight: "bold", color: "maroon" }}
                                  >
                                    {a.tip}
                                    {" - "}
                                    <SLink target="_blank" href={a.link.url}>
                                      {a.link.title}
                                    </SLink>
                                  </Typography>
                                </>
                              )}
                            </Box>
                          </div>
                        );
                      })}
                  </>
                )}
              </Grid>
            </>
          );
        })}

      <Grid
        item
        xs={12}
        md={8}
        margin="auto"
        sx={{ paddingLeft: "0px !important" }}
      >
        {showEmail2 ? (
          <EmailCapture
            handleSubmit={(name, email) => {
              handleSubmit(name, email);
              setShowEmail2(false);
            }}
            title="Get a copy of your personalised report"
          />
        ) : (
          <Alert
            severity="success"
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                m: "auto",
                color: "primary.main",
                textAlign: "center",
              }}
            >
              Your email is on its way! ✨
            </Typography>
          </Alert>
        )}
      </Grid>

      <Dialog
        open={showEmail && showNextSteps}
        onClose={() => {
          setShowNextSteps(false);
          setShowEmail(false);
        }}
      >
        <Box
          sx={{
            width: "100%",
            background: "#db5935",
          }}
        >
          <Box
            sx={{
              width: "100%",
              textAlign: "right",
            }}
          >
            <CloseIcon
              onClick={() => {
                setShowNextSteps(false);
                setShowEmail(false);
              }}
              sx={{
                cursor: "pointer",
                "&:hover": { background: "whitesmoke" },
              }}
            />
          </Box>
          {showEmail && (
            <EmailCapture handleSubmit={handleSubmit} title="Next Steps" />
          )}
        </Box>
      </Dialog>

      <Grid item xs={12} md={8} margin="auto">
        <Typography
          variant="h4"
          textAlign="center"
          width="100%"
          color="primary.main"
          p={2}
          fontWeight="bold"
        >
          See How You Score In Other Areas Of Your Financial Life
        </Typography>
        <Typography>
          We have similar tests for a range of other areas if your financial
          life. To see how you are doing, and to also receive a personalised
          score and report, please choose one of the other sections below. Each
          individial section will take no more than 2 minutes to complete.
        </Typography>
        <br />
        <SelectASection setSelectedSection={navigate} useLinks />
      </Grid>

      <Grid item xs={12}>
        <Typography textAlig="center" p={4}>
          This content is for guidance and educational purposes only and is
          generic in nature. The UK Care Guide website does not offer advice. We
          recommend you seek professional advice from a suitably qualified and
          regulated professional adviser for financial issues, or other suitable
          professionals, for other issues that may be raised through the
          wellbeing assessment tool or on the UK Care Guide website.
          <br></br>
          <br></br>
          {/* People & Technology Limited are registered in England & Wales (company
          number - 13319892). Data Protection Registration - ZB223920. Please
          click{" "}
          <a target="_blank" href="https://helpandadvice.co.uk/privacy-policy/">
            here
          </a>{" "}
          to view our privacy policy. */}
        </Typography>
      </Grid>
    </Grid>
  );
}
